import { Effect, Layer } from "effect";
import { recordingInitialLinkFailure } from "./initial-link-model.ts";
import { RecordingInitialLinkIo } from "./initial-link-service.ts";

export const RecordingInitialLinkIoLive = Layer.succeed(RecordingInitialLinkIo, RecordingInitialLinkIo.of({
  parameter: Effect.try({ try: () => typeof window === "undefined" ? null : new URLSearchParams(window.location.search).get("flowRecording"), catch: recordingInitialLinkFailure })
}));
